import { render, staticRenderFns } from "./SalesByProductCard.vue?vue&type=template&id=a72b0b60&"
import script from "./SalesByProductCard.vue?vue&type=script&lang=js&"
export * from "./SalesByProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports